<template>
  <div style="position: absolute;top: 110px;left: 270px">

    <div class="el-card" style="display: flex; justify-content: flex-start;margin-bottom: 10px;position: relative;left:-40px" >
      <el-input placeholder="请输入用户名查询" prefix-icon="el-icon-search" v-model="tableData.username" style="width: 260px;margin-right: 10px"></el-input>
<!--      <el-input  placeholder="请输入付款方式" prefix-icon="el-icon-search" v-model="tableData.paymentMethod" style="width: 260px;margin-right: 10px"></el-input>
      <el-input  placeholder="请输入金额" prefix-icon="el-icon-search" v-model="tableData.amount" style="width: 260px;margin-right: 10px"></el-input>-->
     <el-button style="background-color: rgb(16,163,127);margin-right: -5px" @click="mohu">搜索</el-button>
      <el-button type="info" @click="clear">重置</el-button>
    </div>

    <div class="el-card1" style="display: flex; justify-content: flex-start;margin-bottom: 10px;border: none;position: relative;left: -40px">
      <el-button style="background-color: rgb(16,163,127)" @click="dialogFormVisible = true">新增用户</el-button>
    </div>

    <div>
      <el-table
        border
        :data="tableData"
        style="width: 100%;position: relative;left: -40px;">
        <el-table-column prop="id" label="ID" width="80px"></el-table-column>
        <el-table-column prop="username" label="用户名" width="140px"></el-table-column>
        <el-table-column prop="groups" label="分组" width=170px></el-table-column>
        <el-table-column prop="user_phone" label="手机号" width=170px></el-table-column>
        <el-table-column prop="name" label="企业名称" width=170px></el-table-column>
        <el-table-column prop="user_permissions" label="详细权限" width=160px></el-table-column>
        <el-table-column prop="is_staff" label="用户层级" width=160px></el-table-column>
        <el-table-column prop="date_joined" label="创建时间" width=160px></el-table-column>
        <el-table-column prop="date_updated" label="更新时间" width=160px></el-table-column>
        <el-table-column>
          <template #default="scope" >
            <div>
              <el-button style="background-color: rgb(16,163,127);" @click="handleEdit(scope.row)">编辑</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column>
          <template #default="scope" >
            <div>
              <el-button type="danger" plain @click="deleteAll(scope.row.id)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--新增-->
    <el-dialog title="" :visible.sync="dialogFormVisible" width="30%">
      <el-form ref="userForm" :model="userForm" >
        <el-form-item label="用户名">
          <el-input v-model="userForm.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="userForm.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="分组">
          <el-input v-model="userForm.groups" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="userForm.user_phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="企业名称">
          <el-input v-model="userForm.user_name" autocomplete="off"></el-input>
        </el-form-item>
<!--        <el-form-item label="详细权限">
          <el-input v-model="userForm.user_permissions" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="用户层级">
          <el-input v-model="userForm.is_staff" autocomplete="off"></el-input>
        </el-form-item>-->
<!--        <el-form-item label="创建时间">
          &lt;!&ndash; 这里不需要用户输入，所以不显示输入框 &ndash;&gt;
          <span>{{ userForm.date_joined }}</span>
        </el-form-item>
        <el-form-item label="更新时间">
          <el-date-picker
            v-model="userForm.date_updated"
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addSave">保 存</el-button>
      </div>
    </el-dialog>


    <!--编辑修改-->
    <el-dialog title="" :visible.sync="dialogFormVisible1" width="30%">
      <el-form ref="userForm1" :model="userForm1" >
        <el-form-item label="用户名">
          <el-input v-model="userForm1.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="userForm1.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="分组">
          <el-input v-model="userForm1.groups" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="userForm1.user_phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="企业名称">
          <el-input v-model="userForm1.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="详细权限">
          <el-input v-model="userForm1.user_permissions" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="用户层级">
          <el-input v-model="userForm1.is_staff" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateEdit">保 存</el-button>
      </div>
    </el-dialog>






  </div>
</template>
<script>
import axios from "axios";
export default {
  data(){
    return{
      tableData: [],
      total: 0,
      pageNum:1,   //当前的页码
      pageSize:6, //每页的个数
      userForm:{id:'', username:'',password:'', groups:'',user_phone:'',user_name:'',user_permissions:'', is_staff:'',date_joined:'',date_updated:''},
      userForm1:{id:'',username:'',password:'', groups:'',user_phone:'',name:'',user_permissions:'', is_staff:'',date_joined:'',date_updated:''},
      dialogTableVisible: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      /*date_joined: new Date().toISOString().substring(0, 10), // 只保留日期部分
      date_updated: '' // 可以保持为空，或者在需要时由用户选择*/
    }
  },
  methods:{
    //回显
    handleEdit(row) {
      this.dialogFormVisible1 = true;
      this.userForm1 = { ...row}; // 使用展开运算符复制当前行数据到userForm
    },
    updateEdit() {
      const payload = {
        user_id: this.userForm1.id,
        username: this.userForm1.username,
        password: this.userForm1.password,
        groups: this.userForm1.groups,
        user_phone: this.userForm1.user_phone,
        name: this.userForm1.name,
        user_permissions: this.userForm1.user_permissions,
        is_staff: this.userForm1.is_staff,
      };
      axios.post("/otherApi/change_user/?user_id=",payload)
        .then(res => {
          if (res.data.code === 200) {
            console.log("修改成功", res);
            this.dialogFormVisible1 = false;
            this.$message({
              message: '数据更新成功!',
              type: 'success',
            });
            this.load(); // 刷新数据表
          } else {
            this.$message.error('更新失败，请稍后再试!');
          }
        })
        .catch(error => {
          console.error('更新用户信息失败:', error);
          this.$message.error('更新失败，请稍后再试!');
        });
    },
    //查询
    load() {
        axios.get('/otherApi/get_usersmessage/', {
      }).then(res => {
          console.log(res)
          // 处理日期格式
          const formattedData = res.data.data.map(item => {
            if (item.date_updated) {
              item.date_updated = item.date_updated.split('.')[0].replace('T', ' ');
            }
            if (item.date_joined) {
              item.date_joined = item.date_joined.split('.')[0].replace('T', ' ');
            }
            return item;
          });
          this.tableData = formattedData;
      }).catch(error => {
        console.error(error);
      });
    },
    //根据企业名称模糊查询
    mohu(){
      axios.get('/otherApi/search_user/', {
        params: {
          username:this.tableData.username,
        }
      }).then(res => {
        console.log(res)
        this.$message.success('查询结果如下~~~');
        this.tableData = res.data.data;
      }).catch(error => {
        console.error(error);
      });
    },
    clear(){
      this.tableData.username='';
      this.load();
    },
    //打开新增的时候把表单数据给清理完
    resetForm() {
      this.userForm = '';
    },
    //新增企业
    addSave() {
          axios.post("/otherApi/add_user/",this.userForm)
            .then(res => {
              if (res.data.code === 200) {
                console.log(res)
                //打开新增的时候把表单数据给清理完
                this.resetForm();
                this.$message.success("操作成功");
                this.dialogFormVisible=false;
                this.load();
              } else {
                this.$message.error("操作失败");
              }
            })
            .catch(error => {
              console.error("请求失败:", error);
              this.$message.error('新增请求失败');
            });
    },
    //根据id删除企业
    deleteAll(id){
      axios.get("/otherApi/del_user/?user_id="+id,{
      }).then(res =>{
        if (res.data.code === 200){
          console.log(res)
          this.$message.success('删除成功!');
          this.load();
        }else {
          this.$message.success('删除失败!');
        }
      })
    }
  },
  created() {
    this.load();
  }
}
</script>

<style scoped>
/* 整体容器样式 */
.el-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 24px;
  margin-bottom: 20px;
  border: none;
  transition: all 0.3s ease;
}

.el-card:hover {
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
}

/* 搜索区域样式 */
.el-input {
  margin-right: 16px;
}

.el-input__inner {
  height: 40px;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  background-color: #f5f7fa;
  transition: all 0.3s ease;
  padding-left: 40px;
}

.el-input__inner:focus {
  background-color: #ffffff;
  border-color: #409EFF;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
}

.el-input__prefix {
  left: 12px;
  color: #909399;
}

/* 按钮样式 */
.el-button {
  height: 40px;
  padding: 0 24px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
}

.el-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.el-button--success {
  background: linear-gradient(135deg, #10a37f 0%, #0d8c6d 100%);
  color: white;
}

.el-button--success:hover {
  background: linear-gradient(135deg, #0d8c6d 0%, #0b7a5f 100%);
}

.el-button--info {
  background: #f5f7fa;
  color: #606266;
  border: 1px solid #dcdfe6;
}

.el-button--info:hover {
  background: #e4e7ed;
  color: #303133;
}

/* 表格样式 */
.el-table {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-top: 20px;
}

.el-table th {
  background-color: #f8fafc !important;
  color: #1f2937;
  font-weight: 600;
  padding: 16px 0;
  border-bottom: 2px solid #e4e7ed;
}

.el-table td {
  padding: 16px 0;
  color: #4b5563;
}

.el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #f8fafc;
}

.el-table__body tr:hover > td {
  background-color: #f0f9ff !important;
}

/* 表格内按钮样式 */
.el-table .el-button {
  height: 32px;
  padding: 0 16px;
  font-size: 13px;
  border-radius: 6px;
}

.el-table .el-button--text {
  color: #10a37f;
  background: rgba(16, 163, 127, 0.1);
}

.el-table .el-button--text:hover {
  background: rgba(16, 163, 127, 0.2);
}


.el-table .el-button--danger {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

.el-table .el-button--danger:hover {
  background: rgba(239, 68, 68, 0.2);
}

/* 对话框样式 */
.el-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.el-dialog__header {
  background: #f8fafc;
  padding: 20px 24px;
  border-bottom: 1px solid #e4e7ed;
}

.el-dialog__title {
  color: #1f2937;
  font-weight: 600;
  font-size: 18px;
}

.el-dialog__body {
  padding: 24px;
}

.el-form-item__label {
  color: #4b5563;
  font-weight: 500;
}

.el-dialog__footer {
  padding: 16px 24px;
  border-top: 1px solid #e4e7ed;
  background: #f8fafc;
}

/* 响应式布局 */
@media screen and (max-width: 1200px) {
  .el-card {
    padding: 20px;
  }

  .el-input {
    width: 240px !important;
  }

  .el-table {
    font-size: 14px;
  }
}

@media screen and (max-width: 768px) {
  .el-card {
    padding: 16px;
  }

  .el-input {
    width: 200px !important;
  }

  .el-button {
    padding: 0 16px;
  }

  .el-table {
    font-size: 13px;
  }
}

/* 新增用户按钮容器 */
.el-card1 {
  background: transparent;
  box-shadow: none;
  padding: 0;
  margin-bottom: 20px;
}

/* 表格内容垂直居中 */
.el-table .cell {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 表格头部文字居中 */
.el-table th > .cell {
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Table.vue